import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=61258f60&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=61258f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61258f60",
  null
  
)

export default component.exports